var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJointMobility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.309 4.69176C17.2104 4.55237 17.0572 4.47217 16.8951 4.47217C16.733 4.47217 16.5798 4.55427 16.4811 4.69176C16.0091 5.36388 15.1318 6.82462 15.1318 8.25671C15.1318 9.31073 15.921 10.1662 16.8933 10.1662C17.8657 10.1662 18.6548 9.31073 18.6548 8.25671C18.6548 6.82462 17.7776 5.36388 17.309 4.69366V4.69176Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7849 8.97622C11.5719 8.67516 11.2411 8.50195 10.8913 8.50195C10.5414 8.50195 10.2106 8.67929 9.99768 8.97622C8.97861 10.4279 7.08496 13.5828 7.08496 16.6759C7.08496 18.9524 8.78848 20.8 10.8875 20.8C12.9864 20.8 14.69 18.9524 14.69 16.6759C14.69 13.5828 12.7963 10.4279 11.7849 8.98035V8.97622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointMobility);
export default __webpack_public_path__ + "static/media/joint-mobility.60a339d2f6bde19f16a410ad46de229e.svg";
export { ForwardRef as ReactComponent };